import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Typography/Text';
export default function FooterInfo({
  children
}) {
  return /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "sm"
  }, children);
}
FooterInfo.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=info.js.map